export default "__VITE_ASSET__5b018375__"